import React from 'react'

export default props => {
  const { ModalComponent, show, hideAction } = props

  return (
    <React.Fragment>
      {show && (
        <div className={`modal ${show && 'is-active'}`}>
          <div className="modal-background" />

          <div className="modal-content">
            <ModalComponent />
          </div>

          <button
            onClick={hideAction}
            type="button"
            className="modal-close is-large"
            aria-label="close"
          />
        </div>
      )}
      {!show && <div />}
    </React.Fragment>
  )
}
